var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { BuildStatus } from '../../../../enums/build-status';
import { EnumUtil } from '../../../../enums/enum-util';
var FormStateComponent = /** @class */ (function () {
    function FormStateComponent() {
        this.buildStatus = BuildStatus.ReadyToBuild;
        this.stateChanged = new EventEmitter();
        var buildEnums = [
            BuildStatus.ReadyToBuild,
            BuildStatus.Research,
            BuildStatus.Input,
            BuildStatus.Comparison,
            BuildStatus.Approval,
            BuildStatus.Amend,
            BuildStatus.Live
        ];
        this.viewModel = { buildEnums: EnumUtil.toArray(buildEnums) };
    }
    FormStateComponent.prototype.getStatusClass = function (status) {
        var defaultClassValues = 'rounded-circle bg-primary mr-5 ';
        if (status === this.buildStatus) {
            defaultClassValues += 'section-inprogress';
        }
        else if (status < this.buildStatus) {
            defaultClassValues += 'section-complete';
        }
        else {
            defaultClassValues += 'section-notstarted';
        }
        return defaultClassValues;
    };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], FormStateComponent.prototype, "buildStatus", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], FormStateComponent.prototype, "stateChanged", void 0);
    FormStateComponent = __decorate([
        Component({
            selector: 'form-state',
            template: require('./form-state.component.html'),
            styles: [require('./form-state.component.scss')],
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [])
    ], FormStateComponent);
    return FormStateComponent;
}());
export { FormStateComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1zdGF0ZS5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmb3JtLXN0YXRlLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLGlCQUFpQixFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsWUFBWSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRzFGLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxnQ0FBZ0MsQ0FBQztBQUM3RCxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sNkJBQTZCLENBQUM7QUFRdkQ7SUFNSTtRQUhnQixnQkFBVyxHQUFnQixXQUFXLENBQUMsWUFBWSxDQUFDO1FBQ25ELGlCQUFZLEdBQThCLElBQUksWUFBWSxFQUFlLENBQUM7UUFHdkYsSUFBSSxVQUFVLEdBQWtCO1lBQzVCLFdBQVcsQ0FBQyxZQUFZO1lBQ3hCLFdBQVcsQ0FBQyxRQUFRO1lBQ3BCLFdBQVcsQ0FBQyxLQUFLO1lBQ2pCLFdBQVcsQ0FBQyxVQUFVO1lBQ3RCLFdBQVcsQ0FBQyxRQUFRO1lBQ3BCLFdBQVcsQ0FBQyxLQUFLO1lBQ2pCLFdBQVcsQ0FBQyxJQUFJO1NBQ25CLENBQUM7UUFFRixJQUFJLENBQUMsU0FBUyxHQUFHLEVBQUUsVUFBVSxFQUFFLFFBQVEsQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQztJQUNsRSxDQUFDO0lBQ00sMkNBQWMsR0FBckIsVUFBc0IsTUFBbUI7UUFDckMsSUFBSSxrQkFBa0IsR0FBVyxpQ0FBaUMsQ0FBQztRQUVuRSxJQUFJLE1BQU0sS0FBSyxJQUFJLENBQUMsV0FBVyxFQUFFO1lBQzdCLGtCQUFrQixJQUFJLG9CQUFvQixDQUFDO1NBQzlDO2FBQU0sSUFBSSxNQUFNLEdBQUcsSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUNsQyxrQkFBa0IsSUFBSSxrQkFBa0IsQ0FBQztTQUM1QzthQUFNO1lBQ0gsa0JBQWtCLElBQUksb0JBQW9CLENBQUM7U0FDOUM7UUFDRCxPQUFPLGtCQUFrQixDQUFDO0lBQzlCLENBQUM7SUEzQlE7UUFBUixLQUFLLEVBQUU7OzJEQUE0RDtJQUMxRDtRQUFULE1BQU0sRUFBRTtrQ0FBc0IsWUFBWTs0REFBZ0Q7SUFKbEYsa0JBQWtCO1FBTjlCLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSxZQUFZO1lBQ3RCLFFBQVEsRUFBRSxPQUFPLENBQUMsNkJBQTZCLENBQUM7WUFDaEQsTUFBTSxFQUFFLENBQUMsT0FBTyxDQUFDLDZCQUE2QixDQUFDLENBQUM7WUFDaEQsYUFBYSxFQUFFLGlCQUFpQixDQUFDLElBQUk7U0FDeEMsQ0FBQzs7T0FDVyxrQkFBa0IsQ0ErQjlCO0lBQUQseUJBQUM7Q0FBQSxBQS9CRCxJQStCQztTQS9CWSxrQkFBa0IifQ==